import {  IntervalObservable  } from './IntervalObservable';

export const interval = IntervalObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/interval.ts